import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const Products = () => {

    const [values, setValues] = useState([15, 500]);

    const handleChange = (index, newValue) => {
        let newValues = [...values];
        newValues[index] = parseFloat(newValue);
        if (newValues[0] > newValues[1]) {
            newValues = [newValues[1], newValues[0]];
        }
        setValues(newValues);
    };

    return (
        <>
            <section>
                <div className="inner-banner-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                <div className="inner-banner-heading  wow fadeInLeft" data-wow-duration="2s">
                                    <h2>Products</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="Inner_Product_Sec ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-3 col-12">
                            <div className="bannertabs ">
                                <h5>Price Filter</h5>
                                <div className="range-slider">
                                    <input type="range" min={15} max={500} step={5} value={values[0]}
                                        onChange={(e) => handleChange(0, e.target.value)} />
                                    <input type="range" min={15} max={500} step={5} value={values[1]}
                                        onChange={(e) => handleChange(1, e.target.value)} />
                                    <span className="rangeValues">
                                        Range: ${values[0]} - ${values[1]}
                                    </span>
                                </div>
                                <div className="shop-by-categories">
                                    <h5>Shop By Categories</h5>
                                    <div className="nav1 stroke">
                                        <ul>
                                            <li><Link to="#" className="active">All</Link></li>
                                            <li><Link to="#">Dummy Here</Link></li>
                                            <li><Link to="#">Dummy Here</Link></li>
                                            <li><Link to="#">Dummy Here</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="product_top_bar">
                                <div className="row align-items-center">
                                    <div className="col-lg-3">
                                        <div className="product_heading">
                                            <h4>150 Products found</h4>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="product_select">
                                            <h6>Sort By:</h6>
                                            <select name id>
                                                <option value>Default</option>
                                                <option value>Hight To Low</option>
                                                <option value>Low To High</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="product_show">
                                            <ul>
                                                <li>Show:</li>
                                                <li className="active"><Link to="">12</Link></li>
                                                <li><Link to="">24</Link></li>
                                                <li><Link to="">40</Link></li>
                                                <li><Link to="">60</Link></li>
                                                <li><Link to="">80</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="product_grid">
                                            <ul>
                                                <li>View:</li>
                                                <li>
                                                    <Link to="">
                                                        <i className="fas fa-border-none" />
                                                        <span className="tool_tip"> Grid View</span>
                                                    </Link>
                                                </li>
                                                <li><Link to=""><i className="fas fa-border-all" />
                                                    <span className="tool_tip">Large Grid View</span></Link>
                                                </li>
                                                <li><Link to="">
                                                    <i className="fas fa-border-center-h" />
                                                    <span className="tool_tip">Large Grid View</span></Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="product_main_box">
                                <div className="row">
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-1.png" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-2.png" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-3.png" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-4.png" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-5.png" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-6.jpg" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-7.jpg" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-8.jpg" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-9.jpg" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-10.jpg" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-11.jpg" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <div className="our-products-boxs inner">
                                            <Link to="/product-detail"> <img src="images/our-products-12.jpg" alt="img" /></Link>
                                            <h2><Link to="/product-detail"> Product Name Here</Link></h2>
                                            <p>Category: Name Here</p>
                                            <ul>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><i className="fas fa-star" /></li>
                                                <li><span>4.5k</span></li>
                                            </ul>
                                            <h3>£2499.00</h3>
                                            <Link to="/cart" className="theme-btn-1">Add To Cart</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Products